import { SHOW_OVERLAY, CLOSE_OVERLAY } from '../../../ActionsConst';

export const showOverlay = ({ overlayName = '', overlayContent = '' }) => ({
  overlayName,
  overlayContent,
  isActive: true,
  type: SHOW_OVERLAY,
});

export const closeOverlay = () => ({
  type: CLOSE_OVERLAY,
});
